export default __webpack_public_path__ + "static/media/menu.084201ec.svg";